import { useCallback, useEffect, useState } from "react";
import { getCitiesBasedOnCountry, getCitiesBasedOnState,  getCountryList, getPostalCode, getStateBasedOnCountry, getStateVisible } from '../../../util';

const FinanceDropdownsCustomHooks = (addressFormValue,setAddressFormValue) => {
    const initialDropdownsValue = {
        stateList: [],
        companyCitiesList: [],
        companyPostalCodeList: [],
        bankCitiesList: [],
        bankPostalCodeList: [],
    }
    const [dropdowns, setDropdowns] = useState(initialDropdownsValue);
    const [addressLoader, setAddressLoader] = useState(false)
    const currentCountry = sessionStorage.getItem('country');


    const fetchCountryData = useCallback(async () => {
        const countryList = await getCountryList();
        const tempCountry = countryList.find((country) => country.name.toLowerCase() === currentCountry?.toLowerCase());

        if (!tempCountry) return;

        setAddressFormValue((prev) => ({
            ...prev,
            country: { name: currentCountry, code: tempCountry.code }
        }));

        if (getStateVisible(currentCountry)) {
            fetchStatesList(currentCountry);
        } else {
            fetchCompanyCitiesList(currentCountry);
            fetchBankCitiesList(currentCountry);
        }
    }, [currentCountry, setAddressFormValue]);

    useEffect(() => {
        fetchCountryData();
    }, [fetchCountryData]);

    const fetchStatesList = useCallback(async (country) => {
        try {
            setAddressLoader(true);
            const tempStateDropdown = await getStateBasedOnCountry(country);
            setDropdowns((prev) => ({
                ...prev,
                stateList: tempStateDropdown?.data?.data?.states || [],
            }));

            if (addressFormValue?.companyState) {
                fetchCompanyCitiesList(country, addressFormValue.companyState);
            }
            if (addressFormValue?.bankState) {
                fetchBankCitiesList(country, addressFormValue.bankState);
            }
        } catch (err) {
            console.error('Error fetching states:', err);
        } finally {
            setAddressLoader(false);
        }
    }, [addressFormValue?.companyState]);

    const fetchCompanyCitiesList = useCallback(async (country, state) => {
        try {
            setAddressLoader(true);
            const citiesList = getStateVisible(country)
                ? await getCitiesBasedOnState(country, state)
                : await getCitiesBasedOnCountry(country);

            setDropdowns((prev) => ({
                ...prev,
                companyCitiesList: citiesList?.data?.data || [],
            }));
        } catch (err) {
            console.error('Error fetching cities:', err);
        } finally {
            setAddressLoader(false);
        }
    }, []);

    const fetchBankCitiesList = useCallback(async (country, state) => {
        try {
            setAddressLoader(true);
            const citiesList = getStateVisible(country)
                ? await getCitiesBasedOnState(country, state)
                : await getCitiesBasedOnCountry(country);

            setDropdowns((prev) => ({
                ...prev,
                bankCitiesList: citiesList?.data?.data || [],
            }));
        } catch (err) {
            console.error('Error fetching cities:', err);
        } finally {
            setAddressLoader(false);
        }
    }, []);

    useEffect(() => {
        if (addressFormValue?.companyState) {
            fetchCompanyCitiesList(addressFormValue?.country?.name, addressFormValue.companyState);
        }
    }, [addressFormValue?.companyState, fetchCompanyCitiesList]);

    useEffect(() => {
        if (addressFormValue?.bankState) {
            fetchBankCitiesList(addressFormValue?.country?.name, addressFormValue.bankState);
        }
    }, [addressFormValue?.bankState, fetchCompanyCitiesList]);


    const fetchBankPostalCodesList = useCallback(async (city) => {
        try {
            setAddressLoader(true);
            const countryCode = addressFormValue?.country?.code;
            const tempPostalCodeList = await getPostalCode(countryCode, city);

            setDropdowns((prev) => ({
                ...prev,
                companyPostalCodeList: tempPostalCodeList || [],
            }));
        } catch (err) {
            console.error('Error fetching postal codes:', err);
            setDropdowns((prev) => ({ ...prev, companyPostalCodeList: [] }));
        } finally {
            setAddressLoader(false);
        }
    }, [addressFormValue?.country?.code]);


    useEffect(() => {
        if (addressFormValue?.companyCity) {
            fetchBankPostalCodesList(addressFormValue.companyCity);
        }
    }, [addressFormValue?.companyCity, fetchBankPostalCodesList]);

    const fetchCompanyPostalCodesList = useCallback(async (city) => {
        try {
            setAddressLoader(true);
            const countryCode = addressFormValue?.country?.code;
            const tempPostalCodeList = await getPostalCode(countryCode, city);

            setDropdowns((prev) => ({
                ...prev,
                bankPostalCodeList: tempPostalCodeList || [],
            }));
        } catch (err) {
            console.error('Error fetching postal codes:', err);
            setDropdowns((prev) => ({ ...prev, bankPostalCodeList: [] }));
        } finally {
            setAddressLoader(false);
        }
    }, [addressFormValue?.country?.code]);

    useEffect(() => {
        if (addressFormValue?.bankCity) {
            fetchCompanyPostalCodesList(addressFormValue.bankCity);
        }
    }, [addressFormValue?.bankCity, fetchCompanyPostalCodesList]);

    return {
        dropdowns, addressLoader
    }
}

export default FinanceDropdownsCustomHooks;